import React from "react";
import {useTranslation} from "react-i18next";
import {Box, Button, Container, Divider, Typography} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {AUTH_PAGE_PATH, HOME_OVERVIEW_PAGE_PATH} from "../../../layouts/navigation/Navigator";
import {useNavigate} from "react-router-dom";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            display: "flex",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
                fontSize: 100,
            }
        },
        button: {
            marginTop: 20
        },
        divider: {
            margin: 30
        }
    })
);

const ReturnToLoginButton = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const classes = useStyles();

    return <Button className={classes.button} variant="contained" color="primary" fullWidth
                   onClick={() => navigate(AUTH_PAGE_PATH)}>
        {t("buttons.return-to-login")}
    </Button>;
};

const ReturnToStartPageButton = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const classes = useStyles();

    return <Button className={classes.button} variant="contained" color="primary" fullWidth
                   onClick={() => navigate(HOME_OVERVIEW_PAGE_PATH)}>
        {t("buttons.return-to-start")}
    </Button>;
};

type InfoProps = {
    caption: string
    icon: JSX.Element
    infoMessages?: string[]
    redirectToStartPage?: boolean
}

const InfoPageComponents: React.FC<InfoProps> = ({icon, caption, infoMessages, redirectToStartPage}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    return (
        <Container maxWidth={"xs"}>
            <Typography gutterBottom>
                {t(caption)}
            </Typography>

            <Box className={classes.icon}>
                {icon}
            </Box>

            <Divider className={classes.divider}/>

            {infoMessages && infoMessages.map((message, index) => {
                    return <Typography gutterBottom variant={"body2"} key={"info_message_" + index}>
                        {t(message)}
                    </Typography>
                }
            )}
            {redirectToStartPage ? <ReturnToStartPageButton/> : <ReturnToLoginButton/>}
        </Container>
    );
};

export default InfoPageComponents;